import React, { useEffect, useState } from 'react';
import { Grid, Autocomplete, TextField, Typography } from '@mui/material';
import styles from './IncidentTab.module.css';
import { getIncidentChecklists } from 'api/canguard/getIncidentChecklists';
import { useNotificationProvider } from 'hooks';

interface IncidentSelectionProps {
	selectedIncidentChecklist: any;
	handleSelectedIncidentChecklistChange: (checklist: any) => void;
	incidentChecklistInputError: string | undefined;
}

const IncidentSelection: React.FC<IncidentSelectionProps> = (props) => {
	const {
		selectedIncidentChecklist,
		handleSelectedIncidentChecklistChange,
		incidentChecklistInputError,
	} = props;
	const { notifyError } = useNotificationProvider();
	const [incidentChecklists, setIncidentChecklists] = useState<any[]>([]);
	const [loadingIncidentChecklists, setLoadingIncidentChecklists] =
		useState<boolean>(true);

	useEffect(() => {
		fetchIncidentChecklists();
	}, []);

	const fetchIncidentChecklists = async () => {
		try {
			setLoadingIncidentChecklists(true);
			const incidentChecklists = await getIncidentChecklists();
			if (incidentChecklists.length > 0) {
				setIncidentChecklists(incidentChecklists);
				handleSelectedIncidentChecklistChange(incidentChecklists[0]); // if guard wants to submit first shown option (placeholder), this will make it work
			}
		} catch (error) {
			console.error(
				'[IncidentSelection/fetchIncidentChecklists] Error fetching incident checklists:',
				error,
			);
			notifyError('Failed to load incident types. Please try again.');
		} finally {
			setLoadingIncidentChecklists(false);
		}
	};

	return (
		<Grid item className={styles.sectionContainer}>
			<Typography component="div">Choose incident type(s):</Typography>
			<Autocomplete
				value={selectedIncidentChecklist}
				options={incidentChecklists}
				loading={loadingIncidentChecklists}
				loadingText="Loading incident types..."
				onChange={(e, newValue) =>
					handleSelectedIncidentChecklistChange(newValue)
				}
				getOptionLabel={(option) => option.Name || 'Unnamed Incident'}
				isOptionEqualToValue={(option, value) =>
					option.ChecklistID === value.ChecklistID
				}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Incidents"
						variant="outlined"
						fullWidth
						error={!!incidentChecklistInputError}
						helperText={incidentChecklistInputError}
					/>
				)}
			/>
		</Grid>
	);
};

export default IncidentSelection;
